import React from 'react';
import './event-details.css'
import Headerr from '../components/layout/header';
import Navbar from '../components/layout/navbar';
import Eventdetailssec from '../sections/eventdetails';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';


const Eventdetails = () => {

                      const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />

    return ( 
        <>
                  <main className='home-background'>

                    <Headerr />
                    <Eventdetailssec />
                    <Navbar />

            </main>
        </>
     );
}
 
export default Eventdetails;